<template>
  <a-row class="tab-heads">
    <div class="tab-heads-scroll-box">
      <tab-head
        v-for="(tab, index) in tabStore.tabs"
        :key="tab.id"
        :tab="tab"
        :isClosable="tabStore.tabs.length > 1"
        @close="handleCloseTab(tab, index)"
      >
      </tab-head>
    </div>
  </a-row>
</template>
<script setup lang="ts">
import TabHead from './tab-head.vue'
import type { Tab } from '@/libs/tab'
import { useTabStore } from '@/stores/tab'
import { useRouter } from 'vue-router'

const router = useRouter()
const tabStore = useTabStore()

function handleCloseTab(tab: Tab, index: number) {
  tabStore.removeTabByIndex(index)
  if (tabStore.activeTab) {
    let nextTabIndex = 0
    const maxIndex = tabStore.tabs.length - 1
    if (tabStore.activeTab === tab) {
      nextTabIndex = index < maxIndex ? index : maxIndex
    } else {
      nextTabIndex = tabStore.tabs.indexOf(tabStore.activeTab)
    }
    tabStore.setActiveTabByIndex(nextTabIndex)
    router.push(tabStore.activeTab.path)
  }
}
</script>
<style scoped>
.tab-heads {
  position: relative;
  display: inline-flex;
  align-items: baseline;
  width: 100%;
  height: 35px;
  bottom: -1px;
  left: 0;
  overflow-y: hidden;
}
.tab-heads-scroll-box {
  width: fit-content;
  height: 35px;
  white-space: nowrap;
}
</style>
